var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('b-tabs',{attrs:{"content-class":"mt-3"},on:{"activate-tab":function($event){return _vm.changeTabs($event)}}},[_c('b-tab',{attrs:{"title":"گزارش ریالی","active":""}},[_c('list-table',{attrs:{"url":_vm.url,"title":"تعداد تراکنش های ریالی و کارمزد هایش","fields":_vm.fields,"params":_vm.params,"excelroute":true}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }